/* unplugin-vue-components disabled */import script from "./matchProcess.vue?vue&type=script&lang=jsx"
export * from "./matchProcess.vue?vue&type=script&lang=jsx"

import "./matchProcess.vue?vue&type=style&index=0&id=72627582&lang=less&scoped=true"

import exportComponent from "/data1/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72627582"]])

export default __exports__